/* eslint-disable */
<template>
  <div :style="{position: 'sticky', bottom: 0, 'z-index': 1}">
    <b-alert
      v-if="participants.length > 1"
      show
      variant="info"
      class="participants-alert mb-0"
    >
      This page is in use by <b>{{ participantsString }} </b>at the same
      time.
    </b-alert>
  </div>
</template>

<script>
/* eslint-disable */
import _findIndex from 'lodash/findIndex'
import { mapState } from 'vuex';
import { UPDATE_PRESENCE } from '@/store/modules/common/mutation-types';

export default {
  props: {
    entityType: {
      default: '',
      type: String,
    },
    entityId: {
      default: null,
    },
  },
  beforeRouteLeave() {
    this.leaveChannel()
  },
  data() {
    return {
      participants: [],
      locEntityType: '',
      locEntityId: null,
      includes: ['articles', 'companies', 'contacts', 'cases', 'transport-projects'],
      strictIncludes: {
        cases: 'edit',
      },
    }
  },
  computed: {
    entityTypeDefault() {
      const path = this.$route.path.split('/')
      return path[1] || ''
    },
    participantsString() {
      return this.participants
        .filter((item) => item.id !== this.currentUser.id)
        .map((item) => `${item.username}`)
        .join(', ')
    },
    channel() {
      return `entity.${this.locEntityId}.${this.locEntityType}`
    },
    loggedIn() {
      return !!this.currentUser
    },
    ...mapState({
      currentUser: state => state.auth.user,
    }),
  },
  watch: {
    $route(to, from) {
      this.leaveChannel()
      this.initPresenceListeners(this.entityType, this.entityId)
    },

    loggedIn(val) {
      if (!val) {
        this.leaveChannel()
      }
    },
    participants: {
      handler(val, prevVal) {
        if (val.length >= 2 && prevVal.length === 0) {
          this.$store.commit(`common/${UPDATE_PRESENCE}`, {channel: this.channel, flag: true});
        } else if (val.length === 1) {
          this.$store.commit(`common/${UPDATE_PRESENCE}`, {channel: this.channel, flag: false});
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.entityId) {
      this.initPresenceListeners(this.entityType, this.entityId);
    }
  },
  beforeDestroy() {
    this.leaveChannel()
  },
  methods: {
    leaveChannel() {
      if (this.entityId) {
        this.$echo.leave(this.channel)
        this.entityId = null
        this.participants = []
      }
    },
    initPresenceListeners(entityType, id) {
      this.locEntityType = entityType || this.entityTypeDefault
      this.locEntityId = id || this.$route.params.id
      if (this.locEntityId &&
        (Number.isInteger(this.locEntityId) || ['warehouse-priority'].includes(this.locEntityId)) &&
        this.includes.includes(this.locEntityType) &&
        (!this.strictIncludes[this.locEntityType] || this.$route.path.includes(this.strictIncludes[this.locEntityType]))
      ) {
        this.$echo
          .join(this.channel)
          .here((users) => {
            this.participants = [...users]
          })
          .joining((user) => {
            this.participants.push(user)
          })
          .leaving((user) => {
            const index = _findIndex(this.participants, { id: user.id })
            if (index !== -1) {
              this.participants.splice(index, 1)
            }
          })
      }
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/components/Presence.vue